import { WAMNOW_HIDE } from './types';

export const wamDialogsHideWamNowThunkAction = () => ({ type: WAMNOW_HIDE });
